module.exports = __webpack_public_path__ + "img/016-like.618ad918.svg";